import { List, Typography } from "antd"
import { useState, useEffect } from "react"
import API from "../../../../services/API";

export default function AvaAssist({ userId }) {
  const [items, setItems] = useState([]);

  const fetchItems = async () => {
    if (items.length) return;
    try {
      const request = await API.avaAssist(userId);
      setItems(request.positiveChanges);
    } catch (e) {
      console.error('Unable to fetch Ava Assist Items', e);
    }
  };

  useEffect(() => {
    fetchItems();
  }, [userId]);

  return (
    <List header={<Typography.Title level={4}>Ava Assist</Typography.Title>} 
		  bordered
      dataSource={items}
      renderItem={change => <List.Item>{change.value}</List.Item>}
      style={{marginBottom: "20px"}}
    />
  );
}